import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "gw-keyboard-arrow-up",
  "use": "gw-keyboard-arrow-up-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"gw-keyboard-arrow-up\"><path fill=\"none\" d=\"M0 0h24v24H0Z\" /><path d=\"M8.12 14.71 12 10.83l3.88 3.88a.996.996 0 1 0 1.41-1.41L12.7 8.71a.996.996 0 0 0-1.41 0L6.7 13.3a.996.996 0 0 0 0 1.41c.39.38 1.03.39 1.42 0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol